import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormErrorModel } from '../../../projects/ig-core/src/lib/form/form-error.model';
import { IgFormService } from '../../../projects/ig-core/src/lib/form/form.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { IgFormValidator } from 'projects/ig-core/src/lib/form/igFormValidator';
import { saveAs } from 'file-saver';
import { IgFileService } from '@ig-core/form/igFile.service';

@Component({
  selector: 'app-file-management',
  templateUrl: './file-management.component.html',
  styleUrls: ['./file-management.component.css']
})
export class FileManagementComponent implements OnInit, OnDestroy {

  public singleFileForm: FormGroup;
  public multiFileForm: FormGroup;
  public singleFile: File;
  public multiFile: Array<any> = [];
  public multiFileData: Array<File> = [];
  public responseData: Array<any> = [];
  public fileName: string;

  public formError: FormErrorModel;
  public formErrors = {
    singleFile: '',
    fileName: ''
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private igFormService: IgFormService,
    private fileManagementService: IgFileService) {
  }

  ngOnInit() {
    this.buildForm();
    this.formError = new FormErrorModel(false, '');
  }

  ngOnDestroy(): void {
  }

  buildForm() {
    this.singleFileForm = this.formBuilder.group({
      singleFile: ['', ],
      fileName: ['', [Validators.required]]
    });

    this.multiFileForm = this.formBuilder.group({
      multiFile: [[], ]
    });
    this.singleFileForm.valueChanges.pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      this.formErrors = this.igFormService.validateForm(this.singleFileForm, this.formErrors, false);
    });
  }

  onFileChanged(event) {
    this.singleFile = event.target.files[0];
    this.fileName = this.singleFile.name;
  }

  onMultiFileChanged(event) {
    this.multiFileData = [];
    const fileData = event.target.files;
    for (const  data of fileData) {
      this.multiFileData.push(data);
    }
  }

  deleteFile(data) {
    const index = this.multiFileData.indexOf(data);
    this.multiFileData.splice(index, 1);
  }

  singleFIleUpload() {
    this.formError = new FormErrorModel(false, '');
    this.igFormService.markFormGroupTouched(this.singleFileForm);
    if (this.singleFileForm.valid) {
      this.fileManagementService.uploadFIle(this.singleFile).pipe(takeUntil(componentDestroyed(this)))
        .subscribe((response) => this.onSubmitSuccess(response),
        (response) => this.onSubmitError(response));
    } else {
      this.formErrors = this.igFormService.validateForm(this.singleFileForm, this.formErrors, false);
      return false;
    }
  }

  uploadMultiFile() {
    this.fileManagementService.uploadMultipleFIle(this.multiFileData).pipe(takeUntil(componentDestroyed(this)))
        .subscribe((response) => this.onSubmitSuccess(response),
        (response) => this.onSubmitError(response));
  }

  downloadFile(fileType: string, fileExt: string) {
    this.fileManagementService.downloadFile(fileType).pipe(takeUntil(componentDestroyed(this)))
      .subscribe((response: any) => this.downloadFileData(response));
  }

  generateExcel() {
    this.fileManagementService.generateExcelFile().pipe(takeUntil(componentDestroyed(this)))
      .subscribe((response: any) => this.downloadFileData(response));
  }

  generatePdf() {
    this.fileManagementService.generatePdfFile().pipe(takeUntil(componentDestroyed(this)))
      .subscribe((response: any) => this.downloadFileData(response));
  }

  downloadFileData(response: any) {
    if (response.data.size > 0) {
      saveAs(response.data, response.filename);
    } else {
      this.snackBar.open(`Unable to download the file...Please try again`, 'Close');
    }
  }

  private onSubmitSuccess(response) {
    this.snackBar.open(`File Uploaded successfully`, 'Close');
    this.responseData = response.body;
    this.multiFileData = [];
    this.ngOnInit();
  }

  private onSubmitError(response) {
    this.snackBar.open(`Unable to Upload files...Please try again`, 'Close');
  }

}
